import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import tr from 'date-fns/locale/tr';

import CustomInput from "../../../../components/atoms/Input";
import { enamelPaintingRowCells } from "./constants";
import CustomDropdown from "../../../../components/molecules/CustomFilter";

registerLocale('tr', tr)

export default function ProductInformationRow({ rowData, readOnly }) {
    const [workOrders, setWorkOrders] = useState([])
    const [productCodes, setProductCodes] = useState([])

    let { productInformation } = useSelector(state => state.enamelPaintingForm);

    productInformation = readOnly ? rowData : productInformation;

    const { productCode, workOrderId } = productInformation;

    const CustomDatePickerInput = React.forwardRef(({ value, onClick, cell }, ref) => (
        <CustomInput
            onClick={onClick}
            ref={ref}
            className={cell.className}
            placeholder={cell.placeholder}
            id={cell.id}
            name={cell.name}
            value={productInformation[cell.value]}
            workorder
        />
    ));

    return (
        <Form className={`${readOnly ? 'read-only' : 'product-information-row'}`}>
            <div className={`form-row`}>
                <div className='work-order-inputs'>
                    {
                        enamelPaintingRowCells.map((item, index) => {
                            return (
                                <div className='row-cell' key={index}>
                                    {
                                        item.map(cell => {

                                            if (cell.datePicker) {
                                                return (
                                                    <DatePicker
                                                        // selected={date} // todo: fix this
                                                        key={cell.id}
                                                        locale={'tr'}
                                                        customInput={
                                                            <CustomDatePickerInput cell={cell} />
                                                        }
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        timeIntervals={15}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                    />
                                                )
                                            }

                                            let _value = productInformation[cell.value];

                                            if (cell.name === 'workOrderId') {
                                                return (
                                                    <CustomDropdown
                                                        key={cell.id}
                                                        data={workOrders.map(item => item.workOrderId)}
                                                        className={'product-code-enamel'}
                                                        value={workOrderId}
                                                        name={cell.name}
                                                        defaultValue={"İş Emri No"}
                                                    />
                                                )
                                            }

                                            if (cell.name === 'productCode') {
                                                return (
                                                    <CustomDropdown
                                                        key={cell.id}
                                                        data={productCodes.map(item => item.productCode)}
                                                        className={`product-code-enamel ${!workOrderId && 'no-action-allowed disabled'}`}
                                                        value={productCode}
                                                        name={cell.name}
                                                        defaultValue={"Ürün Kodu"}
                                                    />
                                                )
                                            }

                                            return (
                                                <CustomInput
                                                    key={cell.id}
                                                    className={cell.className}
                                                    placeholder={cell.placeholder}
                                                    type={cell.number && 'number'}
                                                    id={cell.id}
                                                    name={cell.name}
                                                    value={_value}
                                                    workorder
                                                />
                                            )
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </Form>
    );
}